import { loggerCan } from '@/data/utils/loggerUtil';
import { ContentType, HttpClient, RequestParams } from './http-client';
import { logger } from '@/logging/logger';

export class ValesDeCaja<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;
	traceDetails: string | undefined;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
		this.traceDetails = process.env.TRACE_DETAILS?.trim();
	}

	findValesDeCaja = (
		storeId: string,
		query?: {
			orderId?: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId } = params as any;
		delete (params as any)._requestId;

		if (
			loggerCan('trace') &&
			(!this.traceDetails || this.traceDetails.includes('findValesDeCaja'))
		) {
			const paramsLogger = logger.child({
				params,
				query: query ?? {},
				body: {},
				methodName: 'findValesDeCaja',
				requestId,
			});
			paramsLogger.trace('API request parameters');
		}

		return this.http.request<
			{
				balance: string;
				valesDeCaja: {
					total: string;
					spent: string;
					pedido: string;
					devolutionId: string;
					frozen: string;
					id: string;
					remaining: string;
				}[];
			},
			void
		>({
			path: `/store/${storeId}/person/@self/vales-de-caja`,
			method: 'GET',
			query: query,
			secure: true,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			...params,
		});
	};
}
